import { useMemo } from 'react'
import { useSWRWithCache } from '@purecarslabs/signal-core/swr/hooks'
import { GenericFetchHookParamsType } from '@purecarslabs/signal-core/contextFetch/types'
import { getAPIDomain } from '@purecarslabs/signal-utils/env/apiDomain'
/* webpack-strip-block:removed */
import { LeadFormSpecResponseType } from './types'

export interface UseLeadFormSpecType extends GenericFetchHookParamsType {
  accountId: string
  categoryName: string
  product: string
}

// this function returns a path to the API call made by useLeadFormSpec
export function getLeadFormSpec(
  accountId: string,
  categoryName: string,
  product: string
): string {
  return `${getAPIDomain(
    '/leads/api'
  )}/v1/forms/${categoryName}/${product}/${accountId}`
}

/**
 * this is a wrapper around useSWRWithCache that can be used to fetch the lead form spec
 * @return {UseLeadFormSpecType | undefined} - undefined until fetch completes, then the lead form spec data
 */
export function useLeadFormSpec({
  accountId,
  categoryName,
  product,
  ...rest
}: UseLeadFormSpecType): LeadFormSpecResponseType | undefined {
  const url = useMemo(() => getLeadFormSpec(accountId, categoryName, product), [
    accountId,
    categoryName,
    product
  ])
  return (
    useSWRWithCache({
      context: 'useLeadFormSpec',
      url,
      /* webpack-strip-block:removed */
      ...rest
      // eslint-disable-next-line prettier/prettier
    })
    /* webpack-strip-block:removed */
  )
}
